<script>
import axios from 'axios';
import Question from './Question';

// All categories of an audit mount their QuestionList at once (see CategoryList.vue),
// each firing a request in created(). Hitting the backend with a burst of parallel
// requests can race a lazy, non-thread-safe domain-metadata init on first access and
// return 500s. Serializing these requests through one shared queue avoids that burst.
let requestQueue = Promise.resolve();

function enqueue(fn) {
  const run = requestQueue.then(fn, fn);
  requestQueue = run.catch(() => {});

  return run;
}

export default {
  name: 'QuestionList',
  components: {
    Question,
  },
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
    privacyAuditId: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      questions: [],
      loadError: false,
    };
  },
  created() {
    this.localDisabled = this.disabled;
    this.loadQuestions();
  },
  methods: {
    loadQuestions() {
      this.loadError = false;

      enqueue(() => axios.get(`/privacyAudit/${this.privacyAuditId}/question`, {
        params: { categoryId: this.categoryId },
      }))
        .then((response) => {
          this.questions = response.data;
        })
        .catch(() => {
          this.loadError = true;
        });
    },
  },
};
</script>

<template>
  <div>
    <v-container v-if="loadError" fluid grid-list-lg pt-2 pa-0>
      <v-alert :value="true" type="error" outline>
        Die Fragen konnten nicht geladen werden.
        <a href="#" @click.prevent="loadQuestions">Erneut versuchen</a>
      </v-alert>
    </v-container>
    <v-container v-else fluid grid-list-lg pt-2 pa-0>
      <div v-for="question in questions" :key="question.id">

        <v-layout row wrap>
          <v-flex md12>
            <!--{{question.text}}-->
            <Question
              :question="question"
              :privacy-audit-id="privacyAuditId"
              :disabled="localDisabled"
            />
          </v-flex>
        </v-layout>

      </div>
    </v-container>
  </div>
</template>
